import EventPublisher from "../../utils/EventPublisher";
import ActionResultEvents from "../../constants/events/ActionResultEvents";


const RESPONSE_CODES_TO_PUBLISH_EVENTS =
    new Map()
        .set("INVALID_SESSION", ActionResultEvents.INVALID_SESSION);

export default class SecureResponseHandler {

    constructor(responseCodesToCallbacks) {
        this.responseCodesToCallbacks = responseCodesToCallbacks;
    }

    handleResponse(response, dataFromAction) {
        response.json()
            .then((responseBody) => {
                if (RESPONSE_CODES_TO_PUBLISH_EVENTS.has(responseBody["code"])) {
                    EventPublisher.publish(RESPONSE_CODES_TO_PUBLISH_EVENTS.get(responseBody["code"]), {});
                } else if (this.responseCodesToCallbacks.has(responseBody["code"])) {
                    this.responseCodesToCallbacks.get(responseBody["code"])(
                        response.headers,
                        responseBody["contents"],
                        dataFromAction);
                } else {
                    EventPublisher.publish(
                        ActionResultEvents.SERVER_ERROR,
                        {
                            "error": "Unhandled Code From Server: " +
                                responseBody["code"]+" with message: " +
                                responseBody["message"]
                        });
                }
            }).catch(
                (error) => {
                    EventPublisher.publish(ActionResultEvents.SERVER_ERROR, {"error": error.toString()})
                });
    }
}